"use strict";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedDropDown = void 0;
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var NestedDropDownModel = /** @class */ (function (_super) {
    __extends(NestedDropDownModel, _super);
    function NestedDropDownModel(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        return _this;
    }
    return NestedDropDownModel;
}(Backbone.Model));
var NestedDropDown = /** @class */ (function (_super) {
    __extends(NestedDropDown, _super);
    function NestedDropDown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NestedDropDown.prototype.events = function () {
        return {
            'click .js-nested-drop-down-prompt': 'onClickPrompt',
            'click .js-nested-drop-down-group-name': 'onClickGroupName',
            'click .js-nested-drop-down-option': 'onClickOption'
        };
    };
    NestedDropDown.createFor = function (el) {
        var select = $(el);
        var placeholder = select.data('placeholder')
            ? $(select.data('placeholder'))
            : null;
        var extractChoice = function (option) { return ({
            label: option.innerHTML,
            value: option.value
        }); };
        // @ts-ignore - fix at will, jQuery/underscore type inference not cooperating
        var options = underscore_1.default.map(select.find('> option').not('[data-prompt]'), extractChoice);
        // @ts-ignore - fix at will, jQuery/underscore type inference not cooperating
        var groups = underscore_1.default.map(select.find('> optgroup'), function (optgroup) { return ({
            label: optgroup.label,
            options: underscore_1.default.map($(optgroup).find('option'), extractChoice)
        }); });
        var prompt = select.find('> option[data-prompt]').val() || select.find(':selected').html() || select.find('option').eq(0).html();
        var model = new NestedDropDownModel({ select: select, prompt: prompt, options: options, groups: groups, placeholder: placeholder });
        var className = 'js-nested-drop-down nested-drop-down';
        var dropDown = new NestedDropDown({ model: model, className: className });
        dropDown.render();
        return select.after(dropDown.$el);
    };
    NestedDropDown.prototype.initialize = function (options) {
        var _this = this;
        var model = options.model;
        if (!model) {
            throw Error(NestedDropDownModel.name + " needs to be valid: " + (options === null || options === void 0 ? void 0 : options.model));
        }
        this.select = model.options.select;
        this.options = model.options.options;
        this.groups = model.options.groups;
        this.prompt = model.options.prompt;
        this.placeholder = model.options.placeholder;
        $(document).on('click', function () {
            _this.promptEl().removeClass('expanded');
            return _this.optionsEl().removeClass('expanded');
        });
        return this.select.on('change', function () {
            return _this.updateLabel();
        });
    };
    NestedDropDown.prototype.optionsEl = function () { return this.$el.find('.js-nested-drop-down-options'); };
    NestedDropDown.prototype.promptEl = function () { return this.$el.find('.js-nested-drop-down-prompt'); };
    NestedDropDown.prototype.render = function () {
        this.$el.html(NestedDropDown.template({ options: this.options, prompt: this.prompt, groups: this.groups }));
        return this;
    };
    NestedDropDown.prototype.onClickPrompt = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.promptEl().toggleClass('expanded');
        this.optionsEl().toggleClass('expanded');
        return this.updatePlaceholder();
    };
    NestedDropDown.prototype.toggleGroupName = function ($groupName) {
        var $options = $groupName.parent().find('.js-nested-drop-down-group-options');
        $groupName.toggleClass('expanded');
        $options.toggleClass('expanded');
    };
    NestedDropDown.prototype.onClickGroupName = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleGroupName($(e.target));
        return this.updatePlaceholder();
    };
    NestedDropDown.prototype.onClickOption = function (e) {
        var _a, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        (_a = this.select) === null || _a === void 0 ? void 0 : _a.val($(e.target).data('value'));
        if (((_b = this.select) === null || _b === void 0 ? void 0 : _b.data('handler')) === 'visit') {
            var val = this.select.val();
            if (typeof val === 'string') {
                window.location.href = val;
            }
            return;
        }
        (_c = this.select) === null || _c === void 0 ? void 0 : _c.trigger('change');
        this.optionsEl().removeClass('expanded');
        this.promptEl().removeClass('expanded');
        return this.updatePlaceholder();
    };
    NestedDropDown.prototype.updateLabel = function () {
        if (this.select) {
            var $selectedOption = this.select.find('option:selected');
            var selectedOptionValue = $selectedOption.val() || '';
            var $containingSelect = this.select.closest('select');
            // retrieve previous value
            var prevSelectedValue = $containingSelect.data('prev');
            // update previous value
            $containingSelect.data('prev', selectedOptionValue);
            // find element for which to remove the "selected" CSS class
            var $containingSelectParent = $containingSelect.parent();
            var $prevSelectedA = $containingSelectParent.find("a[data-value=\"" + prevSelectedValue + "\"]");
            $prevSelectedA.removeClass("selected");
            // collapse parent
            var $groupNameA = $prevSelectedA.closest('li.group').find('a.group-name');
            this.toggleGroupName($groupNameA);
            // find element for which to remove add "selected" CSS class
            var $selectedSelector = $containingSelectParent.find("a[data-value=\"" + selectedOptionValue + "\"]");
            $selectedSelector.addClass("selected");
            this.promptEl().html($selectedOption.text() + '<i></i>');
        }
    };
    NestedDropDown.prototype.updatePlaceholder = function () {
        if (!this.placeholder) {
            return;
        }
        return this.placeholder.css('min-height', this.$el.height() + "px");
    };
    NestedDropDown.template = underscore_1.default.template("\n        <a class=\"prompt js-nested-drop-down-prompt\" href=\"#\"><%= prompt %><i></i></a>\n        <ul class=\"options js-nested-drop-down-options\">\n          <% for (var i = 0; i < options.length; i++) { %>\n            <li>\n              <a href=\"#\"\n                 class=\"option js-nested-drop-down-option <%= prompt == options[i].label ? 'selected' : ''%>\"\n                 data-value=\"<%= options[i].value %>\">\n                <%= options[i].label %>\n              </a>\n            </li>\n          <% } %>\n          <% for (var i = 0; i < groups.length; i++) { %>\n            <li class=\"group\">\n              <a href=\"#\" class=\"group-name js-nested-drop-down-group-name\"><%= groups[i].label %><i></i></a>\n              <ul class=\"group-options js-nested-drop-down-group-options\">\n                <% for (var j = 0; j < groups[i].options.length; j++) { %>\n                  <li>\n                    <a href=\"#\"\n                       class=\"option js-nested-drop-down-option\"\n                       data-value=\"<%= groups[i].options[j].value %>\">\n                      <%= groups[i].options[j].label %>\n                    </a>\n                  </li>\n                <% } %>\n              </ul>\n            </li>\n          <% } %>\n        </ul>\n    ");
    return NestedDropDown;
}(Backbone.View));
exports.NestedDropDown = NestedDropDown;
